import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import BreadcrumbBar from "./components/BreadcrumbBar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "./hooks/useLangPath";
import Seo from "./Seo";

function Cryptocurrencies() {
  const { t } = useTranslation();
  const langPath = useLangPath();

  const coins = [
    { label: "Bitcoin",      path: "/cryptocurrencies/bitcoin-ai-trading-predictions" },
    { label: "Bitcoin Cash", path: "/cryptocurrencies/bitcoin-cash-ai-trading-predictions" },
    { label: "Ethereum",     path: "/cryptocurrencies/ethereum-ai-trading-predictions" },
    { label: "Ripple",       path: "/cryptocurrencies/ripple-ai-trading-predictions" },
    { label: "Litecoin",     path: "/cryptocurrencies/litecoin-ai-trading-predictions" },
    { label: "Solana",       path: "/cryptocurrencies/solana-ai-trading-predictions" },
  ];

  return (
    <>
      <Seo
        title={t("crypto.pageTitle")}
        description={t("crypto.pageDesc")}
        canonical="/cryptocurrencies"
        breadcrumbs={[
          { name: t("common.home"), path: "/" },
          { name: t("nav.cryptocurrencies"), path: "/cryptocurrencies" },
        ]}
      />
      <BreadcrumbBar crumbs={[{ label: t("common.home"), to: langPath("/") }, { label: t("nav.cryptocurrencies") }]} />
      <Container style={{ paddingTop: 24, paddingBottom: 60 }}>
      <h1>{t("crypto.h1")}</h1>
      <p style={{ color: "#6c757d", marginBottom: 32 }}>{t("crypto.pageDesc")}</p>
      <Row>
        {coins.map(({ label, path }) => (
          <Col md={4} key={path}>
            <Link to={langPath(path)} className="text-decoration-none">
              <Card className="mb-4"><Card.Body><Card.Title>{label}</Card.Title></Card.Body></Card>
            </Link>
          </Col>
        ))}
      </Row>
      </Container>
    </>
  );
}

export default Cryptocurrencies;
